import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { PreviewPageType } from 'src/app/models/enums/previewPageType';
import { BaseRequest } from 'src/app/models/requests/baseRequest';
import { DataService } from 'src/app/shared/services/data.service';
import { RenderService } from 'src/app/shared/services/render.service';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-portal-preview-page',
  templateUrl: './portal-preview-page.component.html',
  styleUrls: ['./portal-preview-page.component.scss'],
})
export class PortalPreviewPageComponent implements OnInit {
  constructor(
    private dataService: DataService,
    private renderService: RenderService
  ) {}

  @ViewChild('pageDataContainer') pageDataContainer!: ElementRef;
  openedSidebar: boolean = false;
  showStream: boolean = true;
  generalSettingsData: any;

  nodeId: string | unknown = null;
  urlGetPageData: string = environment.apiUrl + '/umbraco/Surface/PortalPreviewSurface/GetPageData';
  urlGetLayoutData: string = environment.apiUrl + '/umbraco/Surface/PortalPreviewSurface/GetPreviewLayoutData';
  pageData: any | null = null;
  PreviewPageType = PreviewPageType;

  ngOnInit(): void {
    this.nodeId = this.getNodeIdFromLocation();
    if (!this.nodeId) {
      window.location.href = '/404';
      return;
    } 
    this.getLayoutData();
    this.getPreviewPageData();
  }

  //Page type
  getPreviewPageData() {
    let culture = this.dataService.getCultureCode();
    let payload = {
      cultureCode: culture,
      nodeId: this.nodeId,
    };
    this.dataService.getDataByToken(this.urlGetPageData, payload).subscribe({
      next: (data) => {
        //console.log(data);
        this.pageData = data;
        if(this.pageData.url == '/'){
          this.pageData.url = '/home';
        }
      },
      error: (e) => console.error(e),
    });
  }

  getNodeIdFromLocation(): string | null {
    let id = window.location.pathname?.slice(1);
    let num = parseFloat(id);
    return !isNaN(num) ? id : null;
  }

  //Layout
  toggleSidebar(open: boolean) {
    this.openedSidebar = open;
  }

  getLayoutData() {
    let request: BaseRequest = {
      cultureCode: this.dataService.getCultureCode(),
    };
    this.dataService.getLayoutData(this.urlGetLayoutData, request).subscribe({
      next: (data) => {
        data = JSON.parse(data);
        this.generalSettingsData = data;
        this.dataService.shareBtnData = data.shareBtnData;
        setTimeout(() => {
          if (this.pageDataContainer && this.pageDataContainer.nativeElement) {
            this.renderService.bindMessagePopups();
          }
        }, 0);
      },
      error: (e) => console.error(e),
    });
  }
}